import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../App';
import { useAuth } from '../../AuthContext';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen, Users, Trophy, ArrowRight, X } from 'lucide-react';

export default function OnboardingTutorial() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const { user } = useAuth();
  const [step, setStep] = useState(0);
  const [show, setShow] = useState(false);
  const isEN = language === 'en';

  useEffect(() => {
    if (user && !localStorage.getItem('pantass_onboarded')) {
      setShow(true);
    }
  }, [user]);

  const close = () => {
    setShow(false);
    localStorage.setItem('pantass_onboarded', 'true');
  };

  const steps = [
    {
      icon: BookOpen,
      title: isEN ? 'Choose a Subject' : 'Pilih Subjek',
      desc: isEN ? '8 subjects available — Math, Science, BM, English and more. Pick one to start!' : '8 subjek tersedia — Matematik, Sains, BM, English dan lagi. Pilih satu untuk mula!',
      color: '#E85D3A',
    },
    {
      icon: Users,
      title: isEN ? 'Challenge a Friend' : 'Cabaran Kawan',
      desc: isEN ? 'Two players compete on the same screen. Enter team names and start the tug of war!' : 'Dua pemain berlawan pada skrin yang sama. Masukkan nama pasukan dan mula tarik tali!',
      color: '#1a8cff',
    },
    {
      icon: Trophy,
      title: isEN ? 'Win & Learn!' : 'Menang & Belajar!',
      desc: isEN ? 'Answer correctly to pull the rope. Get streaks for bonus points. Share your victory on WhatsApp!' : 'Jawab betul untuk tarik tali. Dapat kombo untuk bonus markah. Kongsi kemenangan di WhatsApp!',
      color: '#22c55e',
    },
  ];

  if (!show) return null;

  const currentStep = steps[step];
  const Icon = currentStep.icon;

  return (
    <div className="onboarding-overlay">
      <motion.div className="onboarding-card" initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}>
        <button className="onboarding-close" onClick={close}><X size={20} /></button>
        <div className="onboarding-dots">
          {steps.map((_, i) => <div key={i} className={`onboarding-dot ${i === step ? 'onboarding-dot-active' : ''}`} style={i === step ? { background: currentStep.color } : {}} />)}
        </div>
        <div className="onboarding-icon" style={{ background: currentStep.color + '15', color: currentStep.color }}>
          <Icon size={36} />
        </div>
        <h2 className="onboarding-title">{currentStep.title}</h2>
        <p className="onboarding-desc">{currentStep.desc}</p>
        <div className="onboarding-actions">
          {step < steps.length - 1 ? (
            <button className="onboarding-next" style={{ background: currentStep.color }} onClick={() => setStep(step + 1)}>
              {isEN ? 'Next' : 'Seterusnya'} <ArrowRight size={18} />
            </button>
          ) : (
            <button className="onboarding-next" style={{ background: currentStep.color }} onClick={close}>
              {isEN ? "Let's Play!" : 'Jom Main!'} <ArrowRight size={18} />
            </button>
          )}
          <button className="onboarding-skip" onClick={close}>{isEN ? 'Skip' : 'Langkau'}</button>
        </div>
      </motion.div>
    </div>
  );
}
